export const ALTERNATE_CONTACT_TYPES = ['BILLING', 'OPERATIONS', 'SECURITY'];
